/**
 * Plantilla por defecto para el quiz de Diagnóstico por imagen (escenario 3).
 * 4 etiquetas y 4 imágenes: cada opción tiene text (etiqueta) e image (path de la imagen que corresponde).
 * image vacío = la web usará los assets locales por defecto.
 */
export const DEFAULT_SCENARIO3_OPTIONS = [
	{ id: 1, text: "Semiluna celular 2 de 3", correct: true, explanation: "", confirmExplanation: "", image: "" },
	{ id: 2, text: "Inflamación intersticial", correct: true, explanation: "", confirmExplanation: "", image: "" },
	{ id: 3, text: "Depósitos subendoteliales (trombos hialinos)", correct: true, explanation: "", confirmExplanation: "", image: "" },
	{ id: 4, text: "Depósitos subendoteliales (asas en alambre)", correct: true, explanation: "", confirmExplanation: "", image: "" },
];
